// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Tabs/Tabs.less
// module id = 240
// module chunks = 2